import { BtnActions, ViewErrors } from '@contexts/Estate/EstateApplication/infrastructure/Types';

export const identityValidationErrors: ViewErrors = {
  RESOURCE_ALREADY_EXISTS: {
    title: '¡Oops!',
    text: 'Al parecer ya tenemos registrado el documento de identidad que ingresaste. Verifícalo o ponte en contacto con nosotros',
    btnText: 'Aceptar',
    btnAction: BtnActions.KEEP_ON_PAGE,
  },
  DEFAULT: {
    title: 'Tuvimos un error inesperado',
    text: 'Algo ocurrió al intentar procesar tu información. Por favor intenta de nuevo.',
    btnText: 'Aceptar',
    btnAction: BtnActions.KEEP_ON_PAGE,
  },
};
